<template>
  <section>
    <v-card
      v-for="position in positions"
      class="my-4 top-space"
      :key="position"
      outlined
      tile
      flat
    >
      <v-card-title v-if="variations[position]">
        <div class="mr-auto">{{capitalize(position)}} Seat Review</div>
        <v-btn
          @click="goTo(1)"
          icon
          x-small
          >
          <v-icon color="primary">
            fal fa-edit
          </v-icon>
        </v-btn>
        <v-btn
          class="mx-2"
          @click="deleteSeat(position)"
          icon
          x-small
          >
          <v-icon color="primary">
            fal fa-trash
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="variations[position]">
        <v-row>
          <v-col class="col-pad" cols="12 prod-key" md="3" lg="3">Seat Style</v-col>
          <v-col class="col-pad" cols="7" md="7" lg="7"><p class="var-desc">{{variations[position].svDescription}}</p></v-col>
          <v-col class="col-pad" cols="5 text-right" md="2" lg="2"><span class="item-total">{{getSeatPrice(variations[position], pricing) | currency}}</span></v-col>
        </v-row>
        <v-row v-if="variations[position].trim">
          <v-col class="col-pad prod-key col-sm-12 col-md-3 col-lg-3">Trim</v-col>
          <v-col class="col-pad col-sm-12 col-md-7 col-lg-7"><p class="var-desc">{{variations[position].trim.description}} {{variations[position].trim.color}}</p></v-col>
          <v-col class="col-sm-3 col-md-2 col-lg-2 col-pad d-none d-sm-block text-right flex-row-reverse"><Swatch :color="variations[position].trim" small /></v-col>
        </v-row>
        <v-row v-if="variations[position].insert">
          <v-col class="col-pad prod-key col-sm-12 col-md-3 col-lg-3">Insert</v-col>
          <v-col class="col-pad col-sm-12 col-md-7 col-lg-7"><p class="var-desc">{{variations[position].insert.description}} {{variations[position].insert.color}}</p></v-col>
          <v-col class="col-sm-3 col-md-2 col-lg-2 col-pad d-none d-sm-block text-right flex-row-reverse"><Swatch :color="variations[position].insert" small /></v-col>
        </v-row>

        <section class="opt-wrap" v-if="options[position] && options[position].length">
          <hr />
          <v-row>
            <v-col class="col-12">
              <h6>
                {{capitalize(position)}} Seat Options Review
                <v-btn
                  class="mx-2"
                  @click="goTo(2)"
                  icon
                  x-small
                >
                  <v-icon color="primary">
                    fal fa-edit
                  </v-icon>
                </v-btn>
              </h6>
            </v-col>
          </v-row>
          <v-row>
            <template v-for="(option, index) in options[position]">
              <OptionDetails
                v-if="option && option.name"
                :key="(option.alias || option.name || 'opt') + '-' + index"
                v-bind="option"
                :position="position"
                :threadColor="(option.style && option.style.name === 'Diamond')
                  ? 'Matching stitching'
                  : ((option.color && option.color.name) || 'N/A')"
                :index="index"
                small
              />
            </template>
          </v-row>
        </section>
      </v-card-text>
    </v-card>
  </section>
</template>

<style scoped lang="scss">
  .v-card__title {
    background-color: $gray-1;
    font-size: 16px;
    font-weight: 700;
    padding: 5px 0 5px 16px !important;

    @media screen and (min-width: 600px) {
      font-size: 20px;
    }
  }
  .v-card__text {
    padding: 10px 20px !important;

    @media screen and (min-width: 600px) {
      padding: 20px 40px !important;
    }

    .var-desc {
      max-width: 100%;
      padding-left: 0;
      padding-right: 0;
      margin-bottom: 0;

      @media screen and (min-width: 600px) {
        max-width: 70%;
      }
    }

    .no-bottom-pad {
      padding: 0 !important;
    }
  }

  .opt-wrap {
    margin: 20px 0;
    padding: 20px 0;
  }

  .col-pad {
    padding: 5px 12px 0;
  }

  .top-space {
    margin-top: 30px !important;
  }

  .prod-key {
    font-size: 16px;
    font-weight: 700;
    color: $text;
  }
  .var-desc {
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 0;

    @media screen and (min-width: 600px) {
      max-width: 70%;
    }
  }
</style>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { capitalize, positions } from '@/utils'
  import OptionDetails from './OptionDetails'
  import Swatch from './Swatch'

  export default {
    components: {
      OptionDetails,
      Swatch,
    },
    props: {
      onlyAcc: Boolean
    },
    computed: {
      ...mapState([
        'variations',
        'pricing',
      ]),
      ...mapGetters([
        'getSeatPrice',
      ]),
      positions,
      options: function() {
        const options = {}
        Object.keys(this.variations).forEach(position => {
          if (this.variations[position].options) {
            options[position] = this.variations[position].options.filter(option => option.added)
          }
        })
        return options
      },
    },
    methods: {
      ...mapMutations([
        'goTo',
        'deleteVariations',
      ]),
      capitalize,
      deleteSeat(row) {
        this.deleteVariations(row)
        if (Object.keys(this.variations).length === 0) {
          this.goTo(0)
        }
      },
    }
  }
</script>
